import { useState, useEffect, useCallback } from "react";
import { api } from "../api/api";

const useAgenda = (filtroInicial = "pendente") => {
  const [agenda, setAgenda] = useState([]);

  const carregarAgenda = useCallback(async (tipoFiltro) => {
    try {
      let endpoint = "/compromissos";
      const params = new URLSearchParams();

      if (tipoFiltro === "pendente") {
        params.append("status", "pendente");
      } else if (tipoFiltro === "concluido") {
        params.append("status", "concluido");
      } else if (tipoFiltro === "audiencia") {
        params.append("tipo", "audiencia");
      } else if (tipoFiltro === "manifestacao") {
        params.append("tipo", "manifestacao");
      }
      // Se for "todos", não passa nenhum parâmetro de status/tipo.

      const queryString = params.toString();
      if (queryString) {
        endpoint += `?${queryString}`;
      }

      const response = await api.get(endpoint);
      setAgenda(response.data);
    } catch (err) {
      console.error("Erro ao carregar agenda:", err);
      if (err.response?.status === 401) {
        setAgenda([]);
      }
    }
  }, []);

  useEffect(() => {
    carregarAgenda(filtroInicial);
  }, [carregarAgenda, filtroInicial]);

  const adicionarCompromisso = async (dados) => {
    try {
      const response = await api.post("/compromissos", dados);
      setAgenda((prev) => [...prev, response.data]);
    } catch (err) {
      console.error("Erro ao adicionar compromisso:", err);
    }
  };

  const deletarCompromisso = async (id) => {
    const confirmar = window.confirm("Deseja excluir este compromisso?");
    if (!confirmar) return;

    try {
      await api.delete(`/compromissos/${id}`);
      setAgenda((prev) => prev.filter((item) => item._id !== id));
    } catch (err) {
      console.error("Erro ao deletar compromisso:", err);
    }
  };

  const concluirCompromisso = async (id) => {
    try {
      const response = await api.patch(`/compromissos/${id}/concluir`);
      setAgenda((prev) =>
        prev.map((item) =>
          item._id === id ? response.data.compromisso : item
        )
      );
    } catch (err) {
      console.error("Erro ao concluir compromisso:", err);
    }
  };

  return {
    agenda,
    carregarAgenda,
    adicionarCompromisso,
    deletarCompromisso,
    concluirCompromisso
  };
};

export default useAgenda;